export default SyntaxError;
